/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { createE } from '../../factoriesNumber.js';
export var eDependencies = {
  createE
};